module.exports = __webpack_public_path__ + "static/media/laptop.dc7e93ff.png";